import DeferredValueTimeline from '../DeferredValueTimeline';

export default function SingleClickDeferred() {
  return (
    <DeferredValueTimeline
      video={{
        src:
          '/videos/use-deferred-value/deferred-03-single-click-deferred',
        length: 60 + 48,
      }}
      clicks={[30]}
      renders={[
        {
          type: 'initial',
          start: 30,
          end: 45,
          values: { count: 1, dCount: 0 },
        },
        {
          type: 'deferred',
          start: 45,
          end: 60 + 18,
          values: { count: 1, dCount: 1 },
        },
      ]}
    />
  );
}
